export default __webpack_public_path__ + "static/media/proximanova-medium.4b4206bd.otf";